import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectFixedRangesVisible,
  splitButtonText,
  toggleFixedRangesVisible,
} from '../pdf-tool-manage/pdf-slice';
import { useAppDispatch } from '../store/store';
import { PDFFixedRangeComponent } from '../pdf-tool-manage/pdf-range-input/pdf-fixed-range-component';
import { PDFCustomRangeComponent } from '../pdf-tool-manage/pdf-range-input/pdf-custom-range-component';

export const SplitPanel: React.FC<{}> = () => {
  const dispatch = useAppDispatch();

  const getSelectFixedRangesVisible = useSelector(selectFixedRangesVisible);
  const selectSplitButtonText = useSelector(splitButtonText);

  return (
    <>
      {getSelectFixedRangesVisible ? (
        <PDFFixedRangeComponent />
      ) : (
        <PDFCustomRangeComponent />
      )}
      <div className="pdf-custom-range__select-link">
        <button onClick={(e) => dispatch(toggleFixedRangesVisible())}>
          {selectSplitButtonText}
        </button>
      </div>
    </>
  );
};
